<div class="header">
	<div class="block-1" [routerLink]="['/']">
		<mat-icon class="icon-size-24 arrow-left" (click)="backBtnClick()" svgIcon="backArrow"></mat-icon>
		<mat-icon class="icon" svgIcon="logo-header"></mat-icon>
	</div>
	<div class="block-2">
		<a href="javascript:void(0)"><img src="./assets/images/header/h-google.png" alt="Google Icon"></a>
		<a href="javascript:void(0)"><img src="./assets/images/header/h-apple.png" alt="App Store Icon"></a>
	</div>
</div>
<div id="login-container">
	<div class="col-xs-12 col-sm-12 col-md-6 px-0 form">
		<div class="titles">
			<h3 class="reset-password">Welcome Back!</h3>
		</div>
		<div class="tabs">
			<span [class.selected]="selectedTab === 'mobile'" (click)="selectedTab = 'mobile'">Login With OTP</span>
			<span [class.selected]="selectedTab === 'email'" (click)="selectedTab = 'email'">Login With Password</span>
		</div>

		<div class="form-container">
			<!--Login with Email-->
			<form *ngIf="selectedTab === 'email'" class="emailForm" [formGroup]=form (autocomplete)="'false'"
				(submit)="onSubmit(form)">
				<div class="form-group">
					<label>Email OR Mobile<sup class="error">*</sup></label>
					<app-input (onChangeEvent)="form.controls.emailOrMobile.setValue($event)"
						(onFocusOutEvent)="markTouchedAndDirty($event, 'emailOrMobile', form)"
						[value]="form.value.emailOrMobile"></app-input>
					<p class="error"
						*ngIf="form.get('emailOrMobile')?.invalid && (form.get('emailOrMobile')?.dirty || form.get('emailOrMobile')?.touched)">
						Please enter valid Email OR Mobile
					</p>
				</div>
				<!-- <div>
					<p class="ortab"> ------------------------ &nbsp; <span> OR </span> &nbsp;
						------------------------ </p>
				</div>
				<div class="form-group">
					<label>Mobile<sup class="error"></sup></label>
					<app-input (onChangeEvent)="form.controls.mobile.setValue($event)"
						(onFocusOutEvent)="markTouchedAndDirty($event, 'mobile', form)"
						[value]="form.value.mobile"></app-input>
					<p class="error"
						*ngIf="form.get('mobile')?.invalid && (form.get('mobile')?.dirty || form.get('mobile')?.touched)">
						Please enter valid Mobile, (with prefix +91)
					</p>
				</div> -->
				<!-- <p class="error"
					*ngIf="form.errors?.emailOrMobile === true && (form.get('mobile')?.touched || form.get('emailId')?.touched)">
					Please enter either EmailId or Mobile
				</p>
				<p class="error"
					*ngIf="form.errors?.emailAndMobile === true && (form.get('mobile')?.touched || form.get('emailId')?.touched)">
					Please enter only one of EmailId or Mobile
				</p> -->
				<div class="form-group">
					<label>Password<sup class="error">*</sup></label>
					<app-input :type="password" (onChangeEvent)="form.controls.password.setValue($event)"
						(onFocusOutEvent)="markTouchedAndDirty($event, 'password', form)"
						[value]="form.value.password"></app-input>
					<p class="error"
						*ngIf="form.get('password')?.invalid && (form.get('password')?.dirty || form.get('password')?.touched)">
						Please enter valid password
					</p>
				</div>
				<div class="col-12 text-center forgot-password-block">
					<a [routerLink]="['/forgot-password']" class="small">Forgot Password?</a>
				</div>
				<div class="col-12 text-center login-btn-block">
					<button type="submit" mat-button class="btn btn-block">Login</button>
				</div>
				<!--<div class="col-12 text-center login-btn-google-block">
					<button type="button" mat-button class="btn btn-block" >Login via Google</button>
				</div>-->
			</form>

			<!--Login with Mobile-->
			<form *ngIf="selectedTab === 'mobile'" [formGroup]=form1 (autocomplete)="'false'"
				(submit)="onSubmit(form1)">
				<div class="form-group">
					<label>Mobile<sup class="error">*</sup></label>
					<div class="prefix-container">
						<span>+91</span>
						<app-input class="input" (onChangeEvent)="form1.controls.mobile.setValue($event)"
							(onFocusOutEvent)="markTouchedAndDirty($event, 'mobile', form1)"
							[value]="form1.value.mobile"></app-input>
					</div>
					<p class="error"
						*ngIf="form1.get('mobile')?.invalid && (form1.get('mobile')?.dirty || form1.get('mobile')?.touched)">
						<!-- Please enter valid Mobile, (with prefix +91) -->
						Please enter valid Mobile
					</p>
				</div>
				<!--<div class="col-12 text-center forgot-password-block">
					<a href="javascript:void(0)" class="small">Forgot Password?</a>
				</div>-->
				<div class="col-12 text-center login-btn-block">
					<button type="submit" mat-button class="btn btn-block">Login</button>
				</div>
				<!--<div class="col-12 text-center login-btn-google-block">
					<button type="button" mat-button class="btn btn-block" >Login via Google</button>
				</div>-->
			</form>
		</div>
	</div>
	<div class="col-xs-12 col-sm-12 col-md-6 px-0 image-container">
		<img src="assets/images/side-image.png" alt="brand-image" />
	</div>
</div>
<div class="footer">
	<div class="col-sm-12 col-xs-12 col-md-12 col-lg-12 px-0">
		<div class="col-sm-12 col-xs-12 col-md-6 col-lg-6 block-1">
			<p>Don't have account?
				<a href="javascript:void(0)" [routerLink]="['/register']">
					<strong>&nbsp;Signup</strong>
				</a>
			</p>
		</div>
		<div class="col-sm-12 col-xs-12 col-md-6 col-lg-6 text-right block-2">
			<a [routerLink]="['/termsandconditions']">Terms & Conditions</a>
			<span>|</span>
			<a [routerLink]="['/privacypolicy']">Privacy Policy</a>
		</div>
	</div>
</div>